import { render, staticRenderFns } from "./Asignacion_prog_v2.vue?vue&type=template&id=38a90701"
import script from "./Asignacion_prog_v2.vue?vue&type=script&lang=js"
export * from "./Asignacion_prog_v2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports